export const login = {
  login: 'Login',
  logout: 'Logout',

  activeAccount: 'First time activation ',
  loading: 'Logging in',
}
